import React from 'react';
import { Section } from './ui/Section';
export function ScienceSection() {
  return <Section background="cream" data-id="element-303">
      <div className="text-center mb-8" data-id="element-304">
        <h2 className="text-2xl md:text-3xl font-bold text-[#1e3a5f] mb-2" data-id="element-305">
          🧠 Lo que la ciencia dice sobre el cerebro de tu hijo...
        </h2>
        <p className="text-[#2d3748] text-sm" data-id="element-306">
          Estudios recientes confirman que el uso excesivo de pantallas genera:
        </p>
      </div>

      <div className="space-y-4" data-id="element-307">
        <div className="bg-white p-5 rounded-xl border border-gray-100 shadow-sm" data-id="element-308">
          <div className="flex items-start gap-4" data-id="element-309">
            <div className="bg-[#e8a020]/20 p-2 rounded-lg shrink-0" data-id="element-310">
              <span className="text-2xl" data-id="element-311">⚡</span>
            </div>
            <div data-id="element-312">
              <h3 className="font-bold text-[#1e3a5f] mb-1" data-id="element-313">
                Dopamina Artificial
              </h3>
              <p className="text-[#2d3748] text-sm leading-relaxed" data-id="element-314">
                El cerebro se acostumbra a recompensas rápidas, matando la
                paciencia y la creatividad.
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white p-5 rounded-xl border border-gray-100 shadow-sm" data-id="element-315">
          <div className="flex items-start gap-4" data-id="element-316">
            <div className="bg-[#1e3a5f]/10 p-2 rounded-lg shrink-0" data-id="element-317">
              <span className="text-2xl" data-id="element-318">🌙</span>
            </div>
            <div data-id="element-319">
              <h3 className="font-bold text-[#1e3a5f] mb-1" data-id="element-320">
                Trastornos del Sueño
              </h3>
              <p className="text-[#2d3748] text-sm leading-relaxed" data-id="element-321">
                La luz azul bloquea la melatonina, impidiendo un descanso
                profundo y reparador.
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white p-5 rounded-xl border border-gray-100 shadow-sm" data-id="element-322">
          <div className="flex items-start gap-4" data-id="element-323">
            <div className="bg-red-50 p-2 rounded-lg shrink-0" data-id="element-324">
              <span className="text-2xl" data-id="element-325">😤</span>
            </div>
            <div data-id="element-326">
              <h3 className="font-bold text-[#1e3a5f] mb-1" data-id="element-327">
                Irritabilidad Crónica
              </h3>
              <p className="text-[#2d3748] text-sm leading-relaxed" data-id="element-328">
                El "síndrome de abstinencia digital" es real y afecta el
                desarrollo emocional de los niños entre 1 y 17 años.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-8 bg-white rounded-xl p-5" data-id="element-329">
        <h3 className="font-bold text-[#1e3a5f] text-lg md:text-xl mb-4 flex items-center gap-2" data-id="element-330">
          <span className="text-2xl" data-id="element-331">⚠️</span> Si no haces nada, esto puede
          empeorar:
        </h3>
        <ul className="space-y-2.5 text-[#2d3748] text-sm md:text-base mb-5" data-id="element-332">
          <li className="flex items-start gap-2" data-id="element-333">
            <span className="text-red-500 mt-0.5" data-id="element-334">✖</span> Más irritabilidad
            cuando intentas poner límites
          </li>
          <li className="flex items-start gap-2" data-id="element-335">
            <span className="text-red-500 mt-0.5" data-id="element-336">✖</span> Menos interés en
            actividades reales
          </li>
          <li className="flex items-start gap-2" data-id="element-337">
            <span className="text-red-500 mt-0.5" data-id="element-338">✖</span> Mayor dependencia
            emocional del celular
          </li>
          <li className="flex items-start gap-2" data-id="element-339">
            <span className="text-red-500 mt-0.5" data-id="element-340">✖</span> Más conflictos
            familiares
          </li>
          <li className="flex items-start gap-2" data-id="element-341">
            <span className="text-red-500 mt-0.5" data-id="element-342">✖</span> Pérdida progresiva
            de autoridad
          </li>
        </ul>
        <p className="text-[#2d3748] text-sm md:text-base mb-2" data-id="element-343">
          Cada semana sin una estrategia clara, el hábito se vuelve más difícil
          de romper.
        </p>
        <p className="text-[#1e3a5f] text-sm md:text-base font-bold" data-id="element-344">
          Pero todavía estás a tiempo de recuperar el equilibrio en casa.
        </p>
      </div>
    </Section>;
}